export default __webpack_public_path__ + "static/media/DaviMarcos_03.0c3f5ab8.jpg";